import React, { useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../../config/Config.js";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log('state >>', state);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    respassword: ""
  })
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch(); 
  const [passworderrormessage, setpassworderrormessage] = useState("");
  const [retypeerrormessage, setretypeerrormessage] = useState("");
  const [passwordnotmatchmessage, setpasswordnotmatchmessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    var ispassworderror = false;
    var isrepassworderror = false;

    if(formData.password) {
      setpassworderrormessage("");
      ispassworderror = false;
    } else {
      setpassworderrormessage("Password cannot be empty")
      ispassworderror = true;
    }

    if(formData.respassword) {
      setretypeerrormessage("");
      isrepassworderror = false;
    } else {
      setretypeerrormessage("Re-Password cannot be empty")
      isrepassworderror = true;
    }

    if( !ispassworderror && !isrepassworderror) {
      if(formData.password == formData.respassword) {
        setpasswordnotmatchmessage("")
        // alert('Form is validated!!');
      } else {
        console.log('password not matching!!');
        setpasswordnotmatchmessage("Password & Re-type password does not match!!");
        return;
      }
    } else {
      console.log('error >>')
      return;
    }

    // if (!state.email || !formData.password) {
    //   alert("Email and password are required");
    //   return;
    // }

    setLoading(true);

    try {
      const res = await axios.post(
        apiUrl + "user-update-password",
        {
          email: state.email,
          password: formData.password,
          reset_token: state.reset_token
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (res.data.status === "success") {
        navigate("/login");
      } else {
        alert(res.data.message || "Something went wrong!!");
      }
    } catch (err) {
      console.error(err);
      alert(
        "Error logging in: " +
          (err.response?.data?.message || err.message || "Network error.")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterClick = () => {
    navigate("/register"); // change to your actual register route
  };

  return (


    <>
<Helmet>
  {/* Meta Title */}
  <title>Login to TheOmSaga | Share Your Spiritual Stories</title>

  {/* Meta Description */}
  <meta
    name="description"
    content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
  />

  {/* Primary Keywords */}
  <meta
    name="keywords"
    content="spiritual stories, spiritual tale, spiritual story telling platform"
  />

  {/* Canonical Tag */}
  <link rel="canonical" href="https://theomsaga.com/login" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Login to TheOmSaga | Share Your Spiritual Stories"
  />
  <meta
    property="og:description"
    content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
  />
  <meta property="og:url" content="https://theomsaga.com/login" />
  <meta
    property="og:image"
    content="https://theomsaga.com/assets/images/login-banner.webp"
  />

  {/* Schema Markup */}
  <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://theomsaga.com/login#webpage",
      "name": "Login to TheOmSaga",
      "url": "https://theomsaga.com/login",
      "description": "Login to TheOmSaga to share spiritual stories, save inspirational spiritual tales, and stay connected with a community of faith and seekers.",
       "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
     
     
      "isPartOf": {
        "@type": "WebSite",
        "name": "TheOmSaga",
        "url": "https://theomsaga.com"
      }
    }
    `}
  </script>
</Helmet>



<div className="login-page-container">
      <div className="login-page-scroll verifyotp-page-scroll resetpassword-page-scroll-div">
        <div className="login-page-main-content">
          <div>
            <p className="login-page-title">RESET PASSWORD</p>
          </div>

          <form className="login-page-form" onSubmit={handleSubmit}>
            <input
              className="login-page-input"
              type="email"
              name="email"
              placeholder="Email"
              value={state?.email}
              onChange={handleChange}
              disabled
            />
            <input
              className="login-page-input"
              type="password"
              name="password"
              placeholder="Password *"
              value={formData.password}
              onChange={handleChange}
            />
            {
                passworderrormessage ?
                <div className="login-page-input-error-div">
                   <p className="register-error-message" style={{textAlign: 'left'}}>{passworderrormessage}</p>
                </div>
                : null
              }
            <input
              className="login-page-input"
              type="password"
              name="respassword"
              placeholder="Re-Password *"
              value={formData.respassword}
              onChange={handleChange}
            />
            {
              retypeerrormessage ?
              <div className="login-page-input-error-div">
                   <p className="register-error-message" style={{textAlign: 'left'}}>{retypeerrormessage}</p>
                </div> : null
            }

            {
              passwordnotmatchmessage ?
              <div className="login-page-input-error-div">
                   <p className="register-error-message" style={{textAlign: 'left'}}>{passwordnotmatchmessage}</p>
                </div> : null
            }
            
            <button className="login-page-button" type="submit" disabled={loading}>
              {loading ? "Loading..." : "Reset"}
            </button>
          </form>
        </div>
      </div>
    </div>
    </>
  
  );
};

export default ResetPassword;
